import Diploma from './Diploma';

export default Diploma;
